import { FilterState } from '@app/core/services/container/filter.service';
import { DataTableView } from '../data-table-new.component';
import { DataTablePageState } from '../directives/datatable-pagination.directive';
import { DataTableSortState } from '../directives/datatable-sort.directive';

export interface DataTableState {
  id: string;
  sort: DataTableSortState;
  page: DataTablePageState;
  filter: FilterState;
  view: string;
}

export class EmptyDataTableState implements DataTableState {
  id: string;
  sort: DataTableSortState;
  page: DataTablePageState;
  filter: FilterState;
  view: string;

  constructor(id: string) {
    this.id = id;
    this.sort = {
      column: '',
      direction: 'asc'
    };

    this.page = {
      index: 0,
      size: 10
    };

    this.filter = {
      search: '',
      value: {}
    };

    this.view = DataTableView.GRID;
  }
}
